var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix)]},_vm._l((_vm.error),function(errorItem){return _c('div',[_vm._v("\n    "+_vm._s(errorItem)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }